<template>
  <footer class="siteFooter">
    <!-- Nav -->
    <div class="siteFooter-nav">
      <div class="siteFooter-nav-content content">
      </div>
    </div>

    <!-- Caption -->
    <div class="siteFooter-caption">
      <div class="siteFooter-caption-content content">
        <a href="http://alpha-stella.com">Copyright © 2011-2024 K-Shin07.</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './../styles/definitions.scss';
.siteFooter {
  position: relative;
  margin: auto 0 0;
  padding: 0px 0 0px;
  bottom: 0;
  border-top: 2px solid #222222;
  z-index: $kZIndexFooter;

  &-nav {
      background: $kFooterColorMain;
    padding: 20px 0 50px;
  }

  &-caption {
    background: $kFooterColorSub;
    &-content {
      padding: 4px 0;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue